// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_r1";
export var checkboxInputColumn = "v_r2";
export var inputOptionRow = "v_pT";
export var inputOptionColumn = "v_pV";